<template>
  <div class="Group">
    <ui-sidebar></ui-sidebar>
    <div class="rightBox clearfix">
      <ui-topbar class="d-none d-lg-block"></ui-topbar>
      <router-view></router-view>
      <ui-footer></ui-footer>
    </div>
  </div>
</template>

<script>
import Topbar from '@/components/layout/Topbar.vue';
import Sidebar from '@/components/layout/Sidebar.vue';
import Footer from '@/components/layout/Footer.vue';
// import Center from '@/components/product/Center.vue';

export default {
  name: 'Group',
  components: {
    'ui-sidebar': Sidebar,
    'ui-footer': Footer,
    'ui-topbar': Topbar
    // 'ui-center': Center
  },
  metaInfo: {
    title: '雪帝数字音频', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '雪帝数字音频'
    },
      {
        name: 'description',
        content: '雪帝数字音频'
      }]
  }
}
</script>

<style scoped lang='less'>
.Group {
  display: flex;
  .rightBox{
    flex: 1;
    margin-left: 50px;
  }
}
@media (max-width: 1200px) {
  .Group{
    div.rightBox{
      margin-left: 30px;
    }
  }
}
@media (max-width: 992px) {
  .Group{
    display: flex;
    flex-direction: column;
    div.rightBox{
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/group/Group.vue